import { Component, Input } from '@angular/core';
import { Protocol } from 'src/app/rent-module/shared/entities/protocol/protocol';
import { ResourceAssignment } from 'src/app/rent-module/shared/entities/resourceAssignment/resourceAssignment';
import { PrimeNGSeverity } from 'src/app/shared-module/shared/types/primeng-severity.type';

@Component({
  selector: 'app-order-rent-resourceAssignment-protocols-view, [app-order-rent-resourceAssignment-protocols-view]',
  templateUrl: './order-rent-resourceAssignment-protocols-view.component.html',
  styleUrls: ['./order-rent-resourceAssignment-protocols-view.component.scss']
})
export class OrderRentResourceAssignmentProtocolsViewComponent {

  _showReviewProtocol = true;
  @Input() set showReviewProtocol(showReviewProtocol: boolean){
    if(showReviewProtocol !== undefined){
      this._showReviewProtocol = showReviewProtocol;
    }
  }
  _showRefuelProtocol = true;
  @Input() set showRefuelProtocol(showRefuelProtocol: boolean){
    if(showRefuelProtocol !== undefined){
      this._showRefuelProtocol = showRefuelProtocol;
    }
  }
  // public outCheck: Protocol; // for later use
  public resourceOut: Protocol;
  public resourceIn: Protocol;
  public refuel: Protocol;
  public review: Protocol;
  // public inCheck: Protocol; // for later use

  _resourceAssignment: ResourceAssignment;
  @Input() set resourceAssignment(resourceAssignment: ResourceAssignment) {
    if (resourceAssignment) {
      this._resourceAssignment = resourceAssignment;
      this._resourceAssignment.protocols?.forEach(protocol => {
        if (protocol.type === 'protocol.rental.resourceOut') {
          this.resourceOut = protocol;
        }
        if (protocol.type === 'protocol.rental.resourceIn') {
          this.resourceIn = protocol;
        }
        if (protocol.type === 'protocol.rental.refuel') {
          this.refuel = protocol;
        }
        if (protocol.type === 'protocol.rental.resourceAssignment.review') {
          this.review = protocol;
        }
      })

    }

  }

  getProtocolStateLabel(protocol: Protocol): string | undefined {
    return Protocol.getStateLabel(protocol);
  }

  getProtocolStateSeverity(protocol: Protocol): PrimeNGSeverity | undefined {
    return Protocol.getStateSeverity(protocol);
  }

  inOrOutProtocolAvailable(): boolean {
    return this.resourceIn !== undefined || this.resourceOut !== undefined;
  }

  refuelProtocolAvailable(): boolean {
    return this.refuel !== undefined;
  }

  reviewProtocolAvailable(): boolean {
    return this.review !== undefined;
  }

  anyProtocolAvailable(): boolean {
    return this.inOrOutProtocolAvailable() || this.refuelProtocolAvailable() || this.reviewProtocolAvailable();
  }
}
